import React from 'react';
import { chapters, extras } from '../data/ebook';
import { Section } from './Section';
export function Contents() {
  return <Section id="contenido" className="bg-white" data-id="element-27" data-mp="os336zrki2jf">
      <div className="max-w-2xl" data-id="element-28" data-mp="12qj7yl5vdiyx">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-sage-dark" data-id="element-29" data-mp="12rklcwacyhjt">
          Qué incluye
        </p>
        <h2 className="mt-5 font-display text-4xl font-light leading-tight text-ink sm:text-5xl" data-id="element-30" data-mp="xpvcnnalyfyw">
          48 páginas, sin relleno. Este es el índice completo.
        </h2>
        <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-31" data-mp="17okujg2i80f5">
          No es un tratado de nutrición de mil páginas. Es el protocolo, en el orden exacto en que
          se aplica.
        </p>
      </div>

      <ol className="mt-14 border-t border-line" data-id="element-32" data-mp="1gj8yn2wcfc2d">
        {chapters.map(chapter => <li key={chapter.title} className="group grid grid-cols-[auto_1fr] items-baseline gap-x-6 gap-y-1 border-b border-line py-6 sm:grid-cols-[9rem_1fr_auto] sm:gap-x-10" data-id="element-33" data-mp="1vg9rxau6nf2y">
            <span className="text-xs font-semibold uppercase tracking-[0.16em] text-sage-dark" data-id="element-34" data-mp="1ft151uyamkvs">
              {chapter.label}
            </span>
            <div data-id="element-35" data-mp="1ose6c0c9k35f">
              <h3 className="font-display text-2xl font-normal leading-snug text-ink" data-id="element-36" data-mp="1orwf5i4gkf4d">
                {chapter.title}
              </h3>
              <p className="mt-1.5 max-w-2xl text-[15px] leading-relaxed text-muted" data-id="element-37" data-mp="1tt291j9uu8fh">
                {chapter.summary}
              </p>
            </div>
            <span className="col-start-2 text-xs tabular-nums text-muted sm:col-start-3 sm:text-right" data-id="element-38" data-mp="23pexa1mmru2u">
              pág. {chapter.page}
            </span>
          </li>)}
      </ol>

      <div className="mt-12 rounded-lg bg-cream p-8 sm:p-10" data-id="element-39" data-mp="2chqq1u57vtlz">
        <h3 className="text-sm font-semibold uppercase tracking-[0.16em] text-ink" data-id="element-40" data-mp="2ch75e5o6mr49">
          Y además, las herramientas
        </h3>
        <ul className="mt-6 grid gap-6 sm:grid-cols-3" data-id="element-41" data-mp="2mfwqe7bdkroq">
          {extras.map(extra => <li key={extra.title} className="flex flex-col" data-id="element-42" data-mp="mdwvvdbuzdx8">
              <h4 className="font-display text-xl text-ink" data-id="element-43" data-mp="meggx2wt2ifh">{extra.title}</h4>
              <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-44" data-mp="hfvc0q6lzakp">{extra.summary}</p>
              <span className="mt-auto pt-3 text-xs tabular-nums text-muted" data-id="element-45" data-mp="w400kascegbe">
                pág. {extra.page}
              </span>
            </li>)}
        </ul>
      </div>
    </Section>;
}